import { z } from 'zod';

const createEnv = () => {
  const EnvSchema = z.object({
    ENVIRONMENT: z.string().optional(),
    BASE_API_URL: z.string(),
    BUGSNAG_API_KEY: z.string().optional(),
    BUGSNAG_ENABLED: z
      .string()
      .refine((it) => it === 'true' || it === 'false')
      .transform((it) => it === 'true')
      .optional(),
    LOG_LEVEL: z.string().optional(),
    OIDC_PROVIDER_URL: z.string(),
    OIDC_CLIENT_ID: z.string(),
    REACT_QUERY_DEV_TOOLS_ENABLED: z
      .string()
      .refine((it) => it === 'true' || it === 'false')
      .transform((it) => it === 'true')
      .optional(),
  });

  const viteVars = Object.entries(import.meta.env)
    .reduce<Record<string, string>>((acc, curr) => {
      const [key, value] = curr;
      if (key.startsWith('VITE_')) {
        acc[key.replace('VITE_', '')] = value;
      }

      return acc;
    }, {});

  // window.__config__ (written by entrypoint.sh at container startup) takes
  // priority over build-time VITE_ vars so the same image works across envs.
  const runtimeConfig = typeof window !== 'undefined' ? window.__config__ : undefined;
  const envVars = { ...viteVars, ...runtimeConfig };

  const parsedEnv = EnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided.
      The following variables are missing or invalid:
      ${Object.entries(parsedEnv.error.flatten().fieldErrors)
        .map(([key, value]) => `${key}: ${value}`)
        .join('\n')
      }`
    );
  }

  return parsedEnv.data;
};

export const env = createEnv();
